import type { ReactNode } from "react";
import styles from "./WorkspaceFrame.module.css";

export type WorkspaceStep = Readonly<{ id: string; label: string; shortLabel?: string }>;

type Props = Readonly<{
  eyebrow: string;
  title: string;
  summary: string;
  steps: readonly WorkspaceStep[];
  activeId: string;
  onSelect: (id: string) => void;
  children: ReactNode;
  actionBar: ReactNode;
  viewMode?: "step" | "complete";
}>;

export function WorkspaceFrame({ eyebrow, title, summary, steps, activeId, onSelect, children, actionBar, viewMode = "step" }: Props) {
  return (
    <article className={`${styles.workspace} ${viewMode === "complete" ? styles.complete : ""}`} data-view-mode={viewMode}>
      <header className={styles.hero}><p>{eyebrow}</p><h1>{title}</h1><span>{summary}</span></header>
      <div className={styles.layout}>
        <nav className={styles.rail} aria-label="Kart bölümleri">
          {steps.map((step, index) => <button key={step.id} type="button" className={activeId === step.id ? styles.active : ""} aria-current={activeId === step.id ? "step" : undefined} onClick={() => onSelect(step.id)}><span>{String(index + 1).padStart(2, "0")}</span>{step.label}</button>)}
        </nav>
        <section className={styles.main}>
          <nav className={styles.stepStrip} aria-label="Kart bölümleri">
            {steps.map((step) => <button key={step.id} type="button" className={activeId === step.id ? styles.active : ""} aria-current={activeId === step.id ? "step" : undefined} onClick={() => onSelect(step.id)}>{step.shortLabel ?? step.label}</button>)}
          </nav>
          <div className={styles.panel}>{children}</div>
          {actionBar}
        </section>
      </div>
    </article>
  );
}
